import type { HomeSummary } from "@/types";

import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";

export default function useHomeSummary() {
  const user = useWeb3UserAddress();
  const { data, isLoading, isError, error, mutate } = useApi<HomeSummary, HomeSummary>(
    {
      path: "/superrewards/exploration/summary/",
      api: "v2",
      params: {
        user: user || undefined,
      },
    },
    {
      strategy: "cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
    refresh: () => mutate(),
  };
}
